// extracted by mini-css-extract-plugin
export var dropdown = "_lr-1";
export var hidden = "_lr-0";